import { type ReactElement } from 'react';
import ImgDesktop from '../../assets/images/header-desktop.png';
import ImgMobile from '../../assets/images/header-responsive.png';
import LogoPE from '../../assets/images/logo-pe.png';
import { ReactComponent as Cgn } from '../../assets/images/cgn-img.svg';
import { ReactComponent as Ctn } from '../../assets/images/ctnotariado.svg';
import { ReactComponent as CNValencia } from '../../assets/images/colegio-valencia.svg';

const Header = (): ReactElement => (
	<header className="c-em-header">
		<picture>
			<source srcSet={ImgMobile} media="(max-width: 768px)" />
			<img className="c-em-header__img" src={ImgDesktop} alt="" />
		</picture>
		<div className="c-em-header__wrap">
			<img className="c-em-header__logo" src={LogoPE} alt="" />
			<h1 className="[ c-em-header__tit ] [ u-mt-16 ]">Presentación del Portal Estadístico del Notariado</h1>
			<div className="[ c-em-header__info ]">
				<p className="c-em-header__info-date"> Viernes 17 de abril a las 10:30 h.</p>
				<p className="c-em-header__info-place">The Terminal Hub (sala Lonja)</p>
				<p className="c-em-header__info-address">Calle de la Travesía s/n 46024 Valencia</p>
			</div>
			<ul className="c-em-header__footer">
				<li>
					<Cgn />
				</li>
				<li>
					<CNValencia />
				</li>
				<li>
					<Ctn />
				</li>
			</ul>
		</div>
	</header>
);

export default Header;
